// modules
import { createAction } from 'redux-actions'

// actions
export const setPathwayList = createAction('SET_PATHWAY_LIST')
export const setPathwayAssignedList = createAction('SET_PATHWAY_ASSIGNED_LIST')

export const setPathwayQuestionList = createAction('SET_PATHWAY_QUESTION_LIST')
export const setPathwayQuestionListModal = createAction(
  'SET_PATHWAY_QUESTION_LIST_MODAL'
)
export const setPathwayQuestionListFilter = createAction(
  'SET_PATHWAY_QUESTION_LIST_FILTER'
)

export const setPathwayPatientList = createAction('SET_PATHWAY_PATIENT_LIST')
export const setPathwayPatientValues = createAction(
  'SET_PATHWAY_PATIENT_VALUES'
)

export const setPathwayFinishMessages = createAction(
  'SET_PATHWAY_FINISH_MESSAGES'
)

export const setPathwayActiveTab = createAction('SET_PATHWAY_ACTIVE_TAB')

export const setPatientAnswerList = createAction('SET_PATIENT_ANSWER_LIST')

export const setPathwayPredefinedFilter = createAction(
  'SET_PATHWAY_PREDEFINED_FILTER'
)

export const resetPathway = createAction('RESET_PATHWAY')
